import React, { useState, useEffect } from 'react';
import './Messages.css';

const mockUsers = [
  { id: 0, name: "AI Assistant", role: "AI" },
  { id: 1, name: "Maria Johnson", role: "Client" },
  { id: 2, name: "Alex Trainer", role: "Trainer" },
  { id: 3, name: "Chris Lee", role: "Trainer" },
  { id: 4, name: "Sam Patel", role: "Client" },
];

const mockConversations = {
  0: [
    { from: "AI Assistant", text: "Hello! 👋 I'm your AI Assistant. Ask me anything about workouts, scheduling, or client management!", time: "09:00", readStatus: false },
    { from: "me", text: "Hi! What can you help me with?", time: "09:01", readStatus: true },
    { from: "AI Assistant", text: "I can help you generate workouts, answer fitness questions, or assist with scheduling. How can I assist you today?", time: "09:01", readStatus: false },
  ],
  1: [
    { from: "me", text: "Hi Maria, how are you feeling today?", time: "09:00", readStatus: true },
    { from: "Maria Johnson", text: "Feeling great! Ready for our session.", time: "09:01", readStatus: false },
  ],
  2: [
    { from: "Alex Trainer", text: "Let's sync up about our clients.", time: "08:30", readStatus: false },
    { from: "me", text: "Sure, let me know your availability.", time: "08:32", readStatus: true },
  ],
  3: [],
  4: [],
};

function Messages() {
  const [search, setSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState(mockUsers[0]);
  const [conversations, setConversations] = useState(mockConversations);
  const [message, setMessage] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 700px)').matches);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (!isMobile) setShowSidebar(true);
  }, [isMobile]);

  useEffect(() => {
    const userId = selectedUser.id;
    const conv = conversations[userId] || [];
    let updated = false;
    const newConv = conv.map(msg => {
      if (msg.from !== "me" && !msg.readStatus) {
        updated = true;
        return { ...msg, readStatus: true };
      }
      return msg;
    });
    if (updated) {
      setConversations(prev => ({
        ...prev,
        [userId]: newConv
      }));
    }
    // eslint-disable-next-line
  }, [selectedUser.id]);

  const filteredUsers = mockUsers.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase())
  );

  const getUnreadCount = (userId) => {
    const conv = conversations[userId] || [];
    return conv.filter(msg => msg.from !== "me" && !msg.readStatus).length;
  };

  const handleSend = () => {
    if (!message.trim()) return;
    setConversations({
      ...conversations,
      [selectedUser.id]: [
        ...(conversations[selectedUser.id] || []),
        { from: "me", text: message, time: new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}), readStatus: true }
      ]
    });
    setMessage('');
  };

  return (
    <div className="messages-dashboard" style={isMobile ? {flexDirection: 'column', height: '80%'} : {}}>
      {(!isMobile || showSidebar) && (
        <div className="sidebar-users" style={isMobile ? {width: '100%', borderRight: 'none', borderBottom: '1px solid #333'} : {}}>
          <input
            type="text"
            placeholder="Search users..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="user-search"
          />
          <ul className="user-list">
            {filteredUsers.map(user => {
              const unread = getUnreadCount(user.id);
              return (
                <li
                  key={user.id}
                  className={selectedUser.id === user.id ? "selected" : ""}
                  onClick={() => {
                    setSelectedUser(user);
                    if (isMobile) setShowSidebar(false);
                  }}
                >
                  <span className="user-avatar">{user.name[0]}</span>
                  <span>
                    {user.name}
                    <span className="user-role">({user.role})</span>
                    {unread > 0 && (
                      <span className="unread-badge">{unread}</span>
                    )}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {(!isMobile || !showSidebar) && (
        <div className="chat-section" style={isMobile ? {width: '100%', flex: 1} : {}}>
          <div className="chat-header">
            {isMobile && (
              <button
                style={{
                  marginRight: 12,
                  background: 'none',
                  border: 'none',
                  color: '#4fd1c5',
                  fontWeight: 'bold',
                  fontSize: 18,
                  cursor: 'pointer'
                }}
                onClick={() => setShowSidebar(true)}
              >
                ←
              </button>
            )}
            <span className="user-avatar">{selectedUser.name[0]}</span>
            <span>
              <b>{selectedUser.name}</b> <span className="user-role">({selectedUser.role})</span>
            </span>
          </div>
          <div className="chat-messages">
            {(conversations[selectedUser.id] || []).map((msg, idx) => (
              <div
                key={idx}
                className={`chat-message ${msg.from === "me" ? "from-me" : "from-them"}`}
              >
                <div className="msg-meta">
                  <span className="msg-from">{msg.from === "me" ? "You" : msg.from}</span>
                  <span className="msg-time">{msg.time}</span>
                </div>
                <div className="msg-text">{msg.text}</div>
              </div>
            ))}
          </div>
          <div className="chat-input-row">
            <input
              type="text"
              placeholder="Type your message..."
              value={message}
              onChange={e => setMessage(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSend()}
              className="chat-input"
            />
            <button onClick={handleSend} className="send-btn">Send</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Messages;